import React from "react";
import banner from "../../image/banner3.png";
import "./home.css";
const HomeBanner = () => {
  return (
    <div className="banner">
      <div
        style={{ height: "83vh" }}
        className="d-flex justify-content-center align-items-center"
      >
        <h1 className=" display-2 text-dark mx-3 text-capitalize">
          welcome to our Pro Active hospital
        </h1>
      </div>
    </div>
  );
};

export default HomeBanner;
